import { Banner } from '@if/mui'
import { useCompany } from '@src/services/company-hooks'
import { useTranslation } from 'react-i18next'
import FailedVendorsList from './FailedVendorsList'

const FailedVendorsSection = () => {
  const { t } = useTranslation()
  const selectedCompany = useCompany()
  const companyId = selectedCompany ? String(selectedCompany) : undefined

  if (!companyId) {
    return <Banner severity="info">{t('admin.transactionRetry.failedVendors.messages.selectCompany')}</Banner>
  }

  return <FailedVendorsList />
}

export default FailedVendorsSection
